module.exports = function() {
  return new Worker("/" + "parcel-html-transpiler.08e457dc.worker.js");
};